import React, { useEffect } from 'react';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useCRUD from 'src/hooks/useCRUD';
import { formatCurrency } from 'src/lib/util/currency-utils';

const OverdueInvoices = ({ userId, onRegisterPayment, customerId, paymentRefresh }) => {
  const { t } = useTranslation('admin', { keyPrefix: 'payments' });

  const { data, loading, fetchData } = useCRUD(`${process.env.REACT_APP_API_URL}/property/${customerId}/user/${userId}/invoices`);

  useEffect(() => {
    if (typeof fetchData === 'function') {
      fetchData();
    }
  }, [paymentRefresh, fetchData]);

  const overdueInvoices =
    data?.invoices?.filter(invoice => {
      if (invoice.paid) return false;
      const dueDate = new Date(invoice.dueDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return dueDate < today;
    }) || [];

  const handleRegisterPayment = invoice => {
    if (onRegisterPayment) {
      onRegisterPayment(invoice);
    }
  };

  if (loading) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography>{t('loading')}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table aria-label="overdue invoices table" sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>{t('columns.concept')}</TableCell>
              <TableCell>{t('columns.dueDate')}</TableCell>
              <TableCell align="right">{t('columns.amount')}</TableCell>
              <TableCell align="right">{t('columns.penalty', 'Monto penalización')}</TableCell>
              <TableCell align="right">{t('columns.total', 'Monto final')}</TableCell>
              <TableCell align="center">{t('columns.actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {overdueInvoices.length === 0 ? (
              <TableRow>
                <TableCell align="center" colSpan={6}>
                  <Typography color="text.secondary">{t('noInvoices')}</Typography>
                </TableCell>
              </TableRow>
            ) : (
              overdueInvoices.map(invoice => {
                const items = JSON.parse(invoice.items || '[]');
                const originalAmount = Array.isArray(items) ? items.reduce((sum, item) => sum + (item.amount || 0), 0) : invoice.amountDue;
                return (
                  <TableRow hover key={invoice.invoiceId}>
                    <TableCell>{Array.isArray(items) ? items?.map(item => item.name).join(', ') : 'N/A'}</TableCell>
                    <TableCell>{new Date(invoice.dueDate).toLocaleDateString()}</TableCell>
                    <TableCell align="right">{formatCurrency(originalAmount)}</TableCell>
                    <TableCell align="right">{invoice.penaltyApplied ? formatCurrency(invoice.amountDue - originalAmount) : 'N/A'}</TableCell>
                    <TableCell align="right">{formatCurrency(invoice.amountDue)}</TableCell>
                    <TableCell align="center">
                      <Button color="primary" onClick={() => handleRegisterPayment(invoice)} sx={{ textDecoration: 'underline' }} variant="text">
                        {t('registerPayment')}
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OverdueInvoices;
